import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=4f076a1a&scoped=true&"
import script from "./Book.vue?vue&type=script&lang=ts&"
export * from "./Book.vue?vue&type=script&lang=ts&"
import style0 from "./Book.vue?vue&type=style&index=0&id=4f076a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f076a1a",
  null
  
)

export default component.exports